import { apiFetch } from "../utils/apiFetch"

export function createApplicant(data: any) {
  return apiFetch("/api/applicants", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data)
  })
}

export function getApplicants() {
  return apiFetch("/api/applicants")
}

export function updateApplicant(id: string, data: any) {
  return apiFetch(`/api/applicants/${id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data)
  })
}

export function deleteApplicant(id: string) {
  return apiFetch(`/api/applicants/${id}`, {
    method: "DELETE"
  })
}
